import { render, staticRenderFns } from "./image.vue?vue&type=template&id=65c12b7e&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"
import style0 from "./image.vue?vue&type=style&index=0&id=65c12b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c12b7e",
  null
  
)

export default component.exports